'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeUnsafeAttributes = removeUnsafeAttributes;
exports.hasDataAttributes = hasDataAttributes;
exports.transformAttributes = transformAttributes;
/**
 * Remove all attributes present on an element, except "safe" ones.
 *
 * Safe is defined, for now, as data attributes, and the id attribute if there
 * are also data attributes.
 *
 * TODO: This should probably be moved and made an apapter method.
 *
 * @param {Object} node
 *
 * @returns {Object} node
 * @private
 */
function removeUnsafeAttributes(node, tagName) {
  var children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var attribs = node.attribs || {};
  node.attribs = Object.keys(attribs).reduce(function (acc, k) {
    if (!/^data-.+/.test(k)) return acc;
    acc[k] = attribs[k];
    return acc;
  }, {});

  // Retain the ID attribute only if there were other safe attributes retained
  // or for empty divs (commonly used as a hook for external JS)
  if (attribs.id && (Object.keys(node.attribs).length || tagName === 'div' && !children.length)) node.attribs.id = attribs.id;
}

function hasDataAttributes(node) {
  var attribs = node.attribs || {};
  return Object.keys(attribs).reduce(function (acc, k) {
    if (acc) return acc;
    return (/^data-.+/.test(k)
    );
  }, false);
}

/**
 * Transform attributes into a more usable format.
 *
 * @param {Array} attributes
 *
 * @returns {Object} hash
 * @private
 */
function transformAttributes(attributes) {
  var hash = {};

  var len = attributes.length;
  while (len) {
    var _attributes = attributes[len - 1],
        name = _attributes.name,
        value = _attributes.value;

    hash[name] = value;
    len--;
  }

  return hash;
}